
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DutyScheduleCalendar',
  props: [
    'currentYear',
    'expandedMonth',
    'showYearPicker',
    'yearPickerStart',
    'yearPickerList',
    'weekDays',
    'dutyStartTime',
    'dutyEndTime',
    'showChangeLog',
    'changeLogs',
    'selectedDateStr',
    'selectedEmployees',
    'showStaffDropdown',
    'availableStaff',
    'staffSearchKeyword',
    'filteredTotal',
    'employeeCurrentPage',
    'employeeTotalPages',
    'offRecords',
    'monthOffDaysMap',
    'selectedDate',
    'changeYear',
    'toggleYearPicker',
    'changeYearPickerRange',
    'selectYear',
    'toggleMonth',
    'getMonthDays',
    'isToday',
    'isSelectedDate',
    'hasOffRecords',
    'onDayClick',
    'onDutyStartTimeChange',
    'onDutyEndTimeChange',
    'toggleChangeLog',
    'onSaveDutyTime',
    'onSaveOffDuty',
    'removeEmployee',
    'isStaffSelected',
    'onEmployeePageChange',
    'toggleStaffDropdown',
    'onStaffSearch',
    'toggleStaff',
    'formatDate'
  ],
  emits: ['update:dutyStartTime', 'update:dutyEndTime', 'update:showChangeLog', 'update:showYearPicker', 'update:showStaffDropdown']
});
